module.exports = __webpack_public_path__ + "72d238cd3f8c8105f0a9c4ec5c522ec1.MP3";